import React, { FC } from 'react';
import { Autocomplete, Box, TextField } from '@mui/material';
import { ADDITIONAL_FIELDS_META } from '../../model';
import { AdditionalFieldsSectionProps } from '../../types/additionalFieldsForm';
import { useAdditionalFieldsHandlers } from '../../hooks/useAdditionalFieldsHandlers';

type ParticipantsSectionProps = AdditionalFieldsSectionProps &
  Pick<
    ReturnType<typeof useAdditionalFieldsHandlers>,
    'handleMultiselectChange'
  >;

export const ParticipantsSection: FC<ParticipantsSectionProps> = ({
  values,
  isFieldsDisabled,
  handleMultiselectChange,
}) => (
  <>
    <Box display="flex" gap={2} flexWrap="wrap">
      <Autocomplete
        disableCloseOnSelect
        multiple
        options={ADDITIONAL_FIELDS_META.amParticipants.enumValues ?? []}
        value={values.amParticipants ?? []}
        disabled={isFieldsDisabled}
        onChange={handleMultiselectChange('amParticipants')}
        renderInput={(params) => (
          <TextField
            {...params}
            label={ADDITIONAL_FIELDS_META.amParticipants.label}
            variant="standard"
            fullWidth
          />
        )}
        sx={{ flex: 1, minWidth: 200 }}
      />
    </Box>

    <Box display="flex" gap={2} flexWrap="wrap">
      <Autocomplete
        disableCloseOnSelect
        multiple
        options={ADDITIONAL_FIELDS_META.tmParticipants.enumValues ?? []}
        value={values.tmParticipants ?? []}
        disabled={isFieldsDisabled}
        onChange={handleMultiselectChange('tmParticipants')}
        renderInput={(params) => (
          <TextField
            {...params}
            label={ADDITIONAL_FIELDS_META.tmParticipants.label}
            variant="standard"
            fullWidth
          />
        )}
        sx={{ flex: 1, minWidth: 200 }}
      />
    </Box>

    <Box display="flex" gap={2} flexWrap="wrap">
      <Autocomplete
        disableCloseOnSelect
        multiple
        options={ADDITIONAL_FIELDS_META.cmParticipants.enumValues ?? []}
        value={values.cmParticipants ?? []}
        disabled={isFieldsDisabled}
        onChange={handleMultiselectChange('cmParticipants')}
        renderInput={(params) => (
          <TextField
            {...params}
            label={ADDITIONAL_FIELDS_META.cmParticipants.label}
            variant="standard"
            fullWidth
          />
        )}
        sx={{ flex: 1, minWidth: 200 }}
      />
    </Box>
  </>
);
